export default "__VITE_ASSET__D0hprXW1__"